var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-edit-dialog', _vm._g({
    attrs: {
      "large": "",
      "cancel-text": "취소",
      "save-text": "변경"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function () {
        return [_c('v-text-field', _vm._b({
          staticClass: "mt-3",
          attrs: {
            "type": "number"
          },
          model: {
            value: _vm.item.sequence,
            callback: function ($$v) {
              _vm.$set(_vm.item, "sequence", $$v);
            },
            expression: "item.sequence"
          }
        }, 'v-text-field', _vm.attrs_input, false))];
      },
      proxy: true
    }])
  }, {
    save: _vm.save
  }), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }